import { Amount } from "../common/common";

export const CURRENCY_NOK = "NOK";

export const formatAmountNumber = (
  amount: number,
  locale: string,
  {
    minimumFractionDigits,
    maximumFractionDigits,
  }: { minimumFractionDigits?: number; maximumFractionDigits?: number } = {},
) => {
  if (!amount) {
    return "";
  }
  const defaultFractionDigits = Number.isInteger(amount) ? 0 : 2;
  return amount.toLocaleString(locale, {
    minimumFractionDigits: minimumFractionDigits ?? defaultFractionDigits,
    maximumFractionDigits: maximumFractionDigits ?? defaultFractionDigits,
  });
};

export const formatAmount = (
  locale: string,
  currencyOrAmount: string | Amount,
  amount?: number,
  options?: { minimumFractionDigits?: number; maximumFractionDigits?: number },
): string => {
  const currency =
    typeof currencyOrAmount === "string" ? currencyOrAmount : currencyOrAmount.currency;
  amount = typeof currencyOrAmount === "string" ? amount : currencyOrAmount.value;
  return amount ? `${currency}\u00A0${formatAmountNumber(amount, locale, options)}` : "";
};

export const formatExactAmount = (locale: string, amount: Amount): string => {
  return `${amount.currency}\u00A0${amount.value.toLocaleString(locale, { maximumFractionDigits: 20 })}`;
};

export const formatPrice = (locale: string, currency: string, price?: number): string =>
  formatAmount(locale, currency, price, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const formatNominalValueNumber = (amount: number, locale: string) =>
  amount.toLocaleString(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 6,
  });

export const formatNominalValue = (locale: string, currency: string, amount?: number): string =>
  amount ? `${currency}\u00A0${formatNominalValueNumber(amount, locale)}` : "";
